/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Data_Export_ButtonInputs */

const en_settings_data_export_button = /** @type {(inputs: Settings_Data_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download My Data`)
};

const de_settings_data_export_button = /** @type {(inputs: Settings_Data_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Daten herunterladen`)
};

const fr_settings_data_export_button = /** @type {(inputs: Settings_Data_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telecharger mes donnees`)
};

const es_settings_data_export_button = /** @type {(inputs: Settings_Data_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar mis datos`)
};

const it_settings_data_export_button = /** @type {(inputs: Settings_Data_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarica i miei dati`)
};

const nl_settings_data_export_button = /** @type {(inputs: Settings_Data_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mijn gegevens downloaden`)
};

const pl_settings_data_export_button = /** @type {(inputs: Settings_Data_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobierz moje dane`)
};

const fi_settings_data_export_button = /** @type {(inputs: Settings_Data_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa tietoni`)
};

const da_settings_data_export_button = /** @type {(inputs: Settings_Data_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download mine data`)
};

const sv_settings_data_export_button = /** @type {(inputs: Settings_Data_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladda ner mina data`)
};

/**
* | output |
* | --- |
* | "Download My Data" |
*
* @param {Settings_Data_Export_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_data_export_button = /** @type {((inputs?: Settings_Data_Export_ButtonInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Data_Export_ButtonInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_data_export_button(inputs)
	if (locale === "fr") return fr_settings_data_export_button(inputs)
	if (locale === "es") return es_settings_data_export_button(inputs)
	if (locale === "it") return it_settings_data_export_button(inputs)
	if (locale === "nl") return nl_settings_data_export_button(inputs)
	if (locale === "pl") return pl_settings_data_export_button(inputs)
	if (locale === "fi") return fi_settings_data_export_button(inputs)
	if (locale === "da") return da_settings_data_export_button(inputs)
	if (locale === "sv") return sv_settings_data_export_button(inputs)
	return en_settings_data_export_button(inputs)
});